// h5
import zmtzPage from '@/views/h5/zmtz/index.vue' // 桌面通知

const routes = [
    {
        path: '/zmtzPage',
        name: 'zmtzPage',
        component: zmtzPage,
        meta: {
            title: '益学堂-通知介绍',
        },
    },
]

export default routes;